"use strict";require("core-js/modules/es.array.for-each");require("core-js/modules/es.array.includes");require("core-js/modules/es.array.index-of");require("core-js/modules/es.array.join");require("core-js/modules/es.array.map");require("core-js/modules/es.array.slice");require("core-js/modules/es.object.keys");require("core-js/modules/es.regexp.exec");require("core-js/modules/es.string.includes");require("core-js/modules/es.string.replace");require("core-js/modules/es.string.split");require("core-js/modules/web.dom-collections.for-each");exports.__esModule = true;exports.default = void 0;

var _is = require("./is");



var _json = require("./json");




function _strArr(arr) {
  var result = [];
  arr.forEach(function (val) {
    var v = (0, _json.str)(val);
    if (!(0, _is.isNull)(v)) {
      result.push(v);
    }
  });
  return result.length === 0 ? null : result.join(',');
}


function stringify(body) {
  if (!(0, _is.isObj)(body) || Object.keys(body) === 0) return '';

  var b = body;
  var pairs = [];

  Object.keys(body).forEach(function (key) {
    var val = b[key];
    if ((0, _is.isArr)(val)) {
      val = _strArr(val);
    } else {
      val = typeof val === 'object' ? (0, _json.str)(val) : val;
    }
    if (!(0, _is.isNil)(val)) {
      pairs.push(key + "=" + val);
    }
  });
  return "?" + pairs.join('&');
}


function parse(query) {
  var keyvals = query.
  replace(/^\?/, '').
  split('&').
  map(function (kvs) {
    var kv = kvs.split('=');
    if (kv.length !== 2) return null;
    return [kv[0], kv[1]];
  });

  var result = {};

  keyvals.forEach(function (kv) {
    if ((0, _is.isNull)(kv)) return;var
    key = kv[0],val = kv[1];
    var v = val.includes(',') ? val.split(',') : val;
    result[key] = v;
  });
  return result;
}

function parseCurrent() {
  var loc = window.location;
  var queryStartInd = loc.href.indexOf('?');
  if (queryStartInd === -1) return {};
  var query = loc.href.slice(queryStartInd);
  return parse(query);

}var _default =

{
  stringify: stringify,
  parse: parse,
  parseCurrent: parseCurrent };exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/queryString.js
// module id = 313
// module chunks = 0